import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import Partners from "./Partners";
import linkedInLogo from "./images/LinkedIn.png";
import imageTeam_EN from "./images/PhotoManagement_EN.png";
import imageTeam_FR from "./images/PhotoManagement_FR.png";
import moez from "./images/moez.png";
import mohamed from "./images/mohamed.jpeg";
import UserIcon from "./images/user.png";

const TeamCard = ({
  name,
  email,
  address,
  phone,
  imageUrl,
  linkedin,
  about = UserIcon,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  const handleSendEmail = () => {
    window.location.href = `mailto:${email}`;
  };

  const toggleAbout = () => {
    setIsExpanded(!isExpanded);
  };
  

  const previewText = about.split("\n")[0];

  return (
    <div className="d-flex flex-column align-items-center border rounded p-3 mb-3 w-100">
      <div className="mb-3">
        <img
          src={imageUrl}
          alt={name}
          className="rounded"
          style={{ width: "100px", height: "130px", objectFit: "cover" }}
        />
      </div>

      <div className="text-center w-100">
        <h4>
          <strong>{t("mr")}</strong> {name}
        </h4>
        <p className="mb-1">
          <strong>{t("email")}: </strong> {email}
        </p>
        <p className="mb-1">
          <strong>{t("phone")}: </strong> {phone}
        </p>
        {address && (
          <p className="mb-1">
            <strong>{t("address")}: </strong> {address}
          </p>
        )}

        <p className="mt-2" style={{ whiteSpace: "pre-line" }}>
          <strong>{t("about")}: </strong> {isExpanded ? about : previewText + "..."}
        </p>
        <span
          onClick={toggleAbout}
          style={{ fontWeight: "bold", cursor: "pointer", color: "#0276c1" }}
        >
          {isExpanded ? t("read_less") : t("read_more")}
        </span>

        <div className="d-flex mt-auto justify-content-center align-items-center mt-3">
          <button
            className="btn btn-sm m-1 blue-color-code text-white"
            onClick={handleSendEmail}
          >
            {t("send_email")}
          </button>
          <a
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2"
          >
            <img
              src={linkedInLogo}
              alt={`${name}'s LinkedIn`}
              className="rounded"
              style={{ width: "30px", height: "30px", objectFit: "cover" }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

const TeamList = () => {
  const { t,i18n } = useTranslation();
  const contacts = t("contacts", { returnObjects: true });

  const language = i18n.language;
  const imageSrc = language === "fr" ? imageTeam_FR : imageTeam_EN;
  return (
    <div className="container mt-2">
      <div className="text-center">
        <img
          src={imageSrc}
          className="img-fluid"
          alt="ourTeam"
          style={{
            maxHeight: "350px",
            maxWidth: "300px",
            minWidth: "60%",
            minHeight: "100%",
            objectFit: "fit",
          }}
        />
      </div>
      <Partners />

      <div className="col-12 text-center animate__animated animate__fadeInDown">
        <h2 className="text-center mb-4"><strong>{t("team")}</strong></h2>
        <div className="d-flex flex-wrap justify-content-center gap-4">
          {contacts.map((contact, index) => (
            <div
              key={index}
              className="d-flex"
              style={{ maxWidth: "400px", width: "100%" }}
            >
              <TeamCard
                {...contact}
                imageUrl={index === 0 ? mohamed : moez}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamList;
